module.exports = __webpack_public_path__ + "img/general-specialities.91f58c72.svg";